<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="isAutoCodeSerialization != 'ACTIVE'">
                <v-text-field
                  name="code"
                  label="Customer Shop Code"
                  v-model="customerShop.code"
                  type="text"
                  :rules="rules.codeRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="isAutoCodeSerialization == 'ACTIVE' && customerShop.id ">
                <v-text-field
                  name="code"
                  label="Customer Shop Code"
                  v-model="customerShop.code"
                  type="text"
                  :rules="rules.codeRules"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Customer Shop Name"
                  v-model="customerShop.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-select
                  :items="customerShopType"
                  label="Choose  Trade Type ..."
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  v-model="customerShop.type"
                  :rules="rules.customerShopTypeRules"
                ></v-select>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="customerShop.shopTypeId"
                  :items="activeShopTypeList"
                  color="blue-grey lighten-2"
                  label="Choose Shop Type..."
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  :rules="rules.shopTypeIdRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm8>
                <v-text-field
                  placeholder="Choose Customer..."
                  v-model="customerName"
                  @click="showCustomers()"
                  :rules="rules.customerIdRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm4>
                <v-btn color="primary" @click="showCustomerForm()" style="float:right">
                  New Customer
                  <v-icon right>add_circle</v-icon>
                </v-btn>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  placeholder="Choose Price Model..."
                  v-model="this.customerShop.priceModelName"
                  @click="showPriceModels()"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="customerShop.cityId"
                  :items="cityList"
                  color="blue-grey lighten-2"
                  label="Choose City..."
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  :rules="rules.cityIdRules"
                  @change="getTownshipByCityId(customerShop.cityId)"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="customerShop.townshipId"
                  :items="townshipList"
                  color="blue-grey lighten-2"
                  label="Choose Township..."
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  :rules="rules.townshipIdRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="locationX"
                  label="Latitude"
                  v-model="customerShop.locationX"
                  type="text"
                  :rules="rules.latitudeRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="locationY"
                  label="Longitude"
                  v-model="customerShop.locationY"
                  type="text"
                  :rules="rules.longitudeRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="address"
                  label="Address"
                  v-model="customerShop.address"
                  type="text"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="phoneNo"
                  label="Phone Number"
                  v-model="customerShop.phoneNo"
                  type="text"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="customerShop.description"
                  type="text"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="customerShop.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="customerShop.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="customerShop.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="customerShop.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="customerShop.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="customerShop.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="customerShop.id">
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn color="primary" :loading="saveLoading" :disabled="!valid || user.role.roleName == 'SALE_MANAGER'" type="submit">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- Customer list dialog -->
    <v-dialog v-model="showCustomerListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="Township"
                label="Township"
                type="text"
                class="mr-1"
                v-model="queryParams.township"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-select
                :items="creditLevelList"
                v-model="queryParams.creditLevelId"
                label="Credit Level"
                item-text="name"
                item-value="id"
                menu-props="auto"
              ></v-select>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Customer List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="activeCustomerList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="setCustomer(props.item), showCustomerListDialog = !showCustomerListDialog"
                  >
                    <a>{{ props.item.name }}</a>
                  </td>
                  <td>{{ props.item.code }}</td>
                  <td>{{ props.item.email }}</td>
                  <td>{{ props.item.phoneNo }}</td>
                  <td>{{ props.item.address }}</td>
                  <td>{{ props.item.creditLevel.name}}</td>
                  <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
                  <td>{{ props.item.updatedBy }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- New customer dialog-->
    <customer-add-dialog
      :showDialog="showCustomerDialog"
      @close="closeCustomerDialog"
    />

    <!-- Price Model dialog -->
    <v-dialog v-model="showPriceModelDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="priceModelQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onPriceModelSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Price Model List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="priceModelHeaders"
                :items="activePriceModelList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalPriceModelRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="priceModelPagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="setPriceModel(props.item.name, props.item.id), showPriceModelDialog = !showPriceModelDialog"
                  >
                    <a>{{ props.item.name }}</a>
                  </td>
                  <td>{{ props.item.description}}</td>
                  <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
                  <td>{{ props.item.updatedBy }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- final message dialog -->
    <v-dialog v-model="messageDialogBox" max-width="500px" @keydown.enter="messageDialogBox=false">
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { CustomerShop, PriceModel } from "../../models/model";
import { Customer } from "../../models/model";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { CustomerShopFormRules } from "../../helpers/validation-rules";
import { CustomerFormRules } from "../../helpers/validation-rules";
import { customerShopService } from "../../services/customer-shop-service";
import { customerService } from "../../services/customer-service";
import { cityService } from "../../services/city-service";
import { creditLevelService } from "../../services/credit-level-service";
import { shopTypeService } from "../../services/shop-type-service";
import { commonService } from "../../services/common-service";
import { priceModelService } from "../../services/price-model-service";
import { regionService } from "../../services/region-service";
import customerAddDialog from "../customer/CustomerAddDialog.vue";

export default {
  name: "CustomerShopDetail",
  components: { VSwitch, customerAddDialog },
  data: () => ({
    valid: true,
    user: JSON.parse(localStorage.getItem("user")),
    isAutoCodeSerialization: JSON.parse(
      localStorage.getItem("AUTO_CODE_SERIALIZATION")
    ),
    breadcrumbs: [
      {
        text: "Customer Shops",
        disabled: false,
        to: "customer-shops"
      },
      {
        text: "Customer Shop Detail",
        disabled: true
      }
    ],
    customerShopType: [
      { label: "WHOLESALE", value: "WHOLESALE" },
      { label: "MODERN_TRADE", value: "MODERN_TRADE" },
      { label: "GENERAL_TRADE", value: "GENERAL_TRADE" }
    ],
    cityId: "",
    createdDate: "",
    updatedDate: "",
    responseError: "",
    saveLoading: false,
    statusFlag: true,
    activeCustomerList: [],
    customerList: [],
    allCustomerList: [],
    cityList: [],
    townshipList: [],
    activeShopTypeList: [],
    tempList: [],
    activePriceModelList: [],
    rules: new CustomerShopFormRules(),
    customerRules: new CustomerFormRules(),
    customerShop: new CustomerShop(),
    oldCustomerShop: new CustomerShop(),
    customer: new Customer(),
    priceModel: new PriceModel(),
    creditLevelList: [],
    showCustomerDialog: false,
    showPriceModelDialog: false,
    messageDialogBox: false,
    showCustomerListDialog: false,
    headers: [
      { text: "Name", align: "left", value: "name" },
      { text: "Code", align: "left", value: "code" },
      { text: "Email", value: "email" },
      { text: "PhoneNo", value: "phoneNo" },
      { text: "Address", value: "address" },
      { text: "Credit Level", value: "creditLevel", sortable: false },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" }
    ],
    priceModelHeaders: [
      { text: "Name", align: "left", value: "name" },
      { text: "Description", align: "left", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" }
    ],
    rowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "name",
      totalItems: 0
    },
    priceModelPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "name",
      totalItems: 0
    },
    totalRows: 0,
    totalPriceModelRows: 0,
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      township: "",
      creditLevelId: ""
    },
    priceModelQueryParams: {
      name: "",
      regionId: "",
      isExistRegion: false,
      status: "ACTIVE"
    },
    showListLoading: false,
    customerName: "",
    priceModelName: "",
    priceModelList: [],
    regionList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getActiveCustomer();
      },
      deep: true
    },
    priceModelPagination: {
      handler() {
        this.getActivePriceModels();
      },
      deep: true
    }
  },
  created() {
    //this.getActiveCustomer();
    this.getAllCity();
    this.getActiveShopTypeList();
    const id = this.$route.params.id;
    if (id == "new") {
      // new Customer
    } else {
      this.getCustomerShopDetail(id);
    }
    this.getRegionList();
    this.getPriceModelList();
  },

  methods: {
    getActiveCustomer() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return customerService
        .getCustomers(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.activeCustomerList = res.data.customerList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    getAllCustomer() {
      var temp;
      var tempCustomerList = [];
      for (var i = 0; i < this.activeCustomerList.length; i++) {
        temp = this.activeCustomerList[i].code;
        if (!this.allCustomerList.includes(temp)) {
          this.allCustomerList.push(temp);
          tempCustomerList.push(this.activeCustomerList[i]);
        }
      }
      for (var j = 0; j < this.customerList.length; j++) {
        temp = this.customerList[j].code;
        if (!this.allCustomerList.includes(temp)) {
          this.allCustomerList.push(temp);
          tempCustomerList.push(this.customerList[j]);
        }
      }
      this.activeCustomerList = tempCustomerList;
    },

    getAllCity() {
      cityService.getAllCity().then(res => {
        this.cityList = res.data.cityList;
      });
    },

    getCustomerShopDetail(id) {
      customerShopService.getCustomerShopDetail(id).then(res => {
        this.customerShop = res.data;
        this.customerList = [res.data.customerDTO];
        this.getTownshipByCityId(this.customerShop.cityId);
        this.customerShop.townshipId = res.data.townshipId;
        this.createdDate = commonService.formatDate(
          new Date(this.customerShop.createdDateInMilliSeconds)
            .toISOString()
            .substr(0, 10),
          "YYYY-MM-DD"
        );
        this.updatedDate = commonService.formatDate(
          new Date(this.customerShop.updatedDateInMilliSeconds)
            .toISOString()
            .substr(0, 10),
          "YYYY-MM-DD"
        );
        this.getAllCustomer();
        this.oldCustomerShop = Object.assign({}, res.data);
        this.statusFlag = this.customerShop.status == "ACTIVE" ? true : false;
        let cust = commonService.search(
          "id",
          this.customerShop.customerId,
          this.customerList
        );
        this.customerName = cust.name;
        this.priceModelName = this.customerShop.priceModelName;
        if (!this.customerShop.priceModelName)
          this.customerShop.priceModelName = "----No Price Model----";
        if (cust.regionId) {
          this.priceModelQueryParams.regionId = cust.regionId;
          this.priceModelQueryParams.isExistRegion = true;
        } else {
          this.priceModelQueryParams.regionId = "";
          this.priceModelQueryParams.isExistRegion = false;
        }
        this.getActivePriceModels();
        this.getShopTypeList();
      });
    },

    getTownshipByCityId(cityId) {
      cityService
        .getCityDetail(cityId)
        .then(res => {
          this.townshipList = res.data.townships;
        })
        .catch(err => {
          console.log(err);
        });
    },

    getShopTypeList() {
      var temp;
      var tempShopList = [];
      temp = this.customerShop.shopTypeDTO.name;
      if (!this.tempList.includes(temp)) {
        this.tempList.push(temp);
        tempShopList.push(this.customerShop.shopTypeDTO);
      }

      for (var j = 0; j < this.activeShopTypeList.length; j++) {
        temp = this.activeShopTypeList[j].name;
        if (!this.tempList.includes(temp)) {
          this.tempList.push(temp);
          tempShopList.push(this.activeShopTypeList[j]);
        }
      }
      this.activeShopTypeList = tempShopList;
    },

    getActiveShopTypeList() {
      shopTypeService.getShopTypeList(this.queryParams).then(res => {
        this.activeShopTypeList = res.data.shopTypeList;
      });
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.customerShop.status = this.statusFlag ? "ACTIVE" : "INACTIVE";
        if (this.customerShop.code == "") {
          this.customerShop.code = null;
        }
        customerShopService
          .saveCustomerShop(this.customerShop)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
              this.messageDialogBox = true;
            }
            this.saveLoading = false;
          });
      }
    },

    clear() {
      this.$refs.form.resetValidation();
      if (!this.customerShop.id) {
        this.customerShop = new CustomerShop();
        this.statusFlag = true;
        this.customerName = "";
      } else {
        this.customerShop = Object.assign({}, this.oldCustomerShop);
        this.getTownshipByCityId(this.customerShop.cityId);
        this.statusFlag = this.customerShop.status == "ACTIVE" ? true : false;
      }
    },

    goBack() {
      this.$router.push("/customer-shops");
    },

    getCreditLevels() {
      creditLevelService
        .getCreditLevels()
        .then(res => {
          if (res.data) {
            this.creditLevelList = res.data.creditLevelList;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    showCustomerForm() {
      this.showCustomerDialog = !this.showCustomerDialog;
    },

    closeCustomerDialog(customer) {
      this.showCustomerDialog = !this.showCustomerDialog;
      if (customer.id) {
        this.activeCustomerList.push(customer);
        this.setCustomer(customer);
      }
    },

    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getActiveCustomer();
    },
    showCustomers() {
      this.getCreditLevels();
      // Clean query params
      this.queryParams.code = "";
      this.queryParams.name = "";
      this.queryParams.township = "";
      this.queryParams.status = "ACTIVE";
      this.queryParams.creditLevelId = "";

      this.getActiveCustomer().then(
        (this.showCustomerListDialog = !this.showCustomerListDialog)
      );
    },
    setCustomer(customer) {
      this.customerShop.customerId = customer.id;
      this.customerName = customer.name;
      if(customer.priceModelId){
        this.customerShop.priceModelId = customer.priceModelId;
        if(customer.priceModelName)
        this.customerShop.priceModelName = customer.priceModelName;
      } else {
        this.customerShop.priceModelName = "";
      }
      if(customer.regionId){
        this.priceModelQueryParams.regionId = customer.regionId;
        this.priceModelQueryParams.isExistRegion = true;
      } else {
        this.priceModelQueryParams.regionId = "";
        this.priceModelQueryParams.isExistRegion = false;
      }
      this.getActivePriceModels();
    },
    onPriceModelSearch() {
      this.priceModelQueryParams.page = this.priceModelPagination.page;
      this.priceModelQueryParams.size = this.priceModelPagination.rowsPerPage;
      this.getActivePriceModels();
    },
    showPriceModels() {
      this.priceModelQueryParams.name = "";
      this.getActivePriceModels().then(
        (this.showPriceModelDialog = !this.showPriceModelDialog)
      );
    },
    setPriceModel(name, id) {
      this.customerShop.priceModelId = id;
      this.customerShop.priceModelName = name;
    },
    getActivePriceModels() {
      this.showListLoading = true;
      let order = this.priceModelPagination.descending ? "desc" : "asc";
      return priceModelService
        .getPriceModelList(
          this.priceModelQueryParams,
          this.priceModelPagination.page,
          this.priceModelPagination.rowsPerPage,
          this.priceModelPagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.activePriceModelList = res.data.data;
            let nopricemodel = {
              id: "",
              name: "----No Price Model----"
            };
            this.activePriceModelList.splice(
              0,
              0,
              JSON.parse(JSON.stringify(nopricemodel))
            );
            this.totalPriceModelRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    changeRegion(){
    this.priceModelQueryParams.regionId = this.customer.regionId;
    if(this.customer.regionId){
      this.priceModelQueryParams.isExistRegion = true;
    } else{
      this.priceModelQueryParams.isExistRegion = false;
    }
    this.getPriceModelList();
    },

    getPriceModelList(){
      priceModelService.getAllPriceModelList(this.priceModelQueryParams)
      .then(res => {
          this.priceModelList = res.data.data;
          let nopricemodel = {
            id: "",
            name: "----No Price Model----"
          };
          this.priceModelList.splice(0, 0, JSON.parse(JSON.stringify(nopricemodel)));
        })
        .catch(err => {
          console.log(err);
        });
    },

     getRegionList() {
      regionService
        .getRegionsByStatus("ACTIVE")
        .then(res => {
          this.regionList = res.data;
          let noregion = {
            id: "",
            name: "----No Region----"
          };
          this.regionList.splice(0, 0, JSON.parse(JSON.stringify(noregion)));
        })
        .catch(err => {
          console.log(err);
        });
    },
  }
};
</script>
